import { Roles } from '@/core/constants/roleConstants';

/*
  EVENT TYPES THAT TRIGGER LOCATION RECORDS
  REFER TO: App\Enums\EmployeeLocationEventType
*/
export const EMPLOYEE_LOCATION_EVENT_TYPE = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  CHANGE_PASSWORD: 'change-password',
};

/*
  ROLES THAT ARE REQUIRED TO GIVE LOCATION ACCESS AND RECORD
  ONLY CONSIDER EMPLOYEES, NEVER INCLUDE CUSTOMERS
*/
export const ROLES_THAT_REGISTER_LOCATION = [
  Roles.SELLER,
  Roles.SUB_MANAGER,
  Roles.MANAGER,
  Roles.REGIONAL_MANAGER,
  Roles.SUB_DIRECTOR,
  Roles.DIRECTOR,
];

/*
  ROLES THAT ARE MULTI-CHANNEL (SELECT CHANNEL VIEW)
  SEND CHANNEL AS NULL IN EMPLOYEE LOCATION MIXIN WHEN CREATING RECORDS
*/
export const ROLES_THAT_SEND_NULL_CHANNEL = [
  Roles.REGIONAL_MANAGER,
  Roles.SUB_DIRECTOR,
  Roles.DIRECTOR,
];

// KEY USED TO FLAG PENDING GPS RECORD AFTER SUCCESS LOGIN
export const PENDING_LOGIN_LOCATION_STORAGE_KEY = 'pendingLoginLocation';
